import { AppBar, Toolbar, Box } from '@mui/material';
import LanguageSelect from './LanguageSelect';
import Logo from './Logo';
import UserOptions from './UserOptions';

function TopBar() {
  return (
    <AppBar position="static">
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Logo
          sx={{ width: '130px', height: '36px' }}
          sxCustomImage={{
            maxWidth: '130px',
            height: '36px',
          }}
        />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <LanguageSelect />
          <UserOptions />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
